import {
  FORM_RECEIVERS,
  FORM_TERMINAL_DATA,
  FORM_ADDRESS,
  FORM_OPEN_HOURS,
  FORM_OBSERVATION
} from './forms-context-service-orders.enum'

import { isSupply } from '@/enums/physical-world.enum.js'
import DateManager from '@/utils/date-manager.utils.js'

import FormOpenHoursManager from './form-open-hours.manager.js'
import FormAddressManager from './form-address.manager.js'
import FormReceiverManager from './form-receiver.manager.js'
import FormTerminalManager from './form-terminal.manager.js'
import FormObservation from './form-observation.manager.js'

class ServiceOrdersFormManager {
  data
  constructor (data) {
    this.data = data
  }

  formOpenHoursFields () {
    const daysOfTheWeek =
      this.data.recipient.location.open_hours.days_of_the_week
    const openHours = Object.keys(daysOfTheWeek).reduce(
      (acc, item) => ({
        ...acc,
        [item]: {
          start: DateManager.hoursFormated(daysOfTheWeek[item].start),
          end: DateManager.hoursFormated(daysOfTheWeek[item].end)
        }
      }),
      {}
    )

    return new FormOpenHoursManager(openHours).getField(FORM_OPEN_HOURS)
  }

  formReceiverFields () {
    return new FormReceiverManager(this.data.recipient).getField(FORM_RECEIVERS)
  }

  formAddressFields () {
    return new FormAddressManager(this.data.recipient).getField(FORM_ADDRESS)
  }

  formObservation () {
    return new FormObservation(this.data.observation).getField(FORM_OBSERVATION)
  }

  formTerminalFields () {
    return new FormTerminalManager(this.data.requested_terminal).getField(
      FORM_TERMINAL_DATA
    )
  }

  getFields () {
    const fields = [
      this.formReceiverFields(),
      this.formAddressFields(),
      this.formObservation(),
      this.formOpenHoursFields()
    ]
    const terminalFields = this.formTerminalFields()
    if (!isSupply(this.data?.type) && terminalFields.fields.length) {
      fields.push(terminalFields)
    }

    return fields
  }
}

export default ServiceOrdersFormManager
